var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 10.6667V6.66667H3.33334L8.00001 2L12.6667 6.66667H10V10.6667H6.00001ZM3.33334 13.3333V12H12.6667V13.3333H3.33334Z",
    fill: "#AFB3C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e6b7249ddbb09d2a65bf8600f88f7a78.svg";
export { ForwardRef as ReactComponent };